import React, { useState } from "react";
import { OutputDataArray, OutputDataObject, Output } from "../../../../../../types/types";
import styles from "../suggestInputForm/SuggestOutput.module.scss";
import OutputItemGroup from "../suggestInputForm/OutputItemGroup";
import OutputItem from "../suggestInputForm/OutputItem";
import { getImageUrl } from "../../../../../../commons/assets_path";
import { useTranslation } from "react-i18next";
import { TagValue } from "../../../../../common/Outputs/TagInputField";

type Props = {
  outputDataArray: OutputDataArray;
  setSuggestPopup: React.Dispatch<React.SetStateAction<{ isVisible: boolean }>>;
  setOutputs: (value: TagValue) => void;
};

const SuggestUrl = ({ outputDataArray, setSuggestPopup, setOutputs }: Props) => {
  const { t } = useTranslation();
  const [localOutputDataArray, setLocalOutputDataArray] = useState<OutputDataArray>(outputDataArray);
  const [currentTab, setCurrentTab] = useState<"outputs">("outputs");
  const [isSearchCompleted, setIsSearchCompleted] = useState(false);

  const closePopup = () => setSuggestPopup({ isVisible: false });

  const search = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm) {
      const filteredOutputs = outputDataArray
        .filter(({ outputs }) => outputs.some(({ display_name }) => display_name.toLowerCase().includes(searchTerm)))
        .map(({ outputs, ...rest }) => ({
          ...rest,
          outputs: outputs.filter(({ display_name }) => display_name.toLowerCase().includes(searchTerm)),
        }));
      setLocalOutputDataArray(filteredOutputs);
      setIsSearchCompleted(filteredOutputs.length > 0);
    } else {
      // searchTermが空（nullや空文字）の場合は、検索を行わずに検索完了フラグをfalseに設定
      setLocalOutputDataArray(outputDataArray); // 元のデータをセット
      setIsSearchCompleted(false);
    }
  };

  return (
    <div>
      <div className={styles.header}>
        <div style={{ display: "flex" }}>
          <div style={{ position: "relative" }}>
            <div
              className={styles.headerInfo}
              onClick={() => setCurrentTab("outputs")}
              data-testid="suggest-output-tab"
            >
              {t("SuggestUrl.取得した値")}
            </div>
            {currentTab === "outputs" && <div className={styles.currentBar} />}
          </div>
        </div>
        <img src={getImageUrl("images/icons/close.svg")} className={styles.closeImg} onClick={() => closePopup()} />
      </div>
      {currentTab === "outputs" ? (
        <div style={{ maxHeight: "28vh", overflowY: "auto" }}>
          <div className={styles.searchForm}>
            <img src={getImageUrl("images/icons/searchGray.svg")} />
            <input
              className={styles.searchInput}
              type="text"
              placeholder={t("SuggestUrl.検索")}
              onChange={(e) => search(e)}
            />
          </div>
          <div className={styles.body}>
            {localOutputDataArray?.map(
              ({ operation_name, icon_type, icon_path, outputs }: OutputDataObject, index: number) => (
                <OutputItemGroup
                  key={index}
                  title={operation_name}
                  image={icon_path}
                  iconType={icon_type}
                  isSearchCompleted={isSearchCompleted}
                  index={index}
                >
                  {outputs?.map(({ id, display_name, test_value }: Output, itemIndex: number) => (
                    <OutputItem key={id} value={display_name}>
                      <div
                        className={styles.outputDisplay}
                        onClick={() =>
                          setOutputs({
                            display_name,
                            icon_path,
                            test_value: test_value !== null ? test_value.replace(/\[,\]/g, ",") : "",
                          })
                        }
                        data-testid={`output-item-${index}-${itemIndex}`}
                      >
                        <div className={styles.outputTitle}>
                          <img
                            src={icon_type === "service" ? icon_path : getImageUrl(icon_path)}
                            className={styles.outputIcon}
                          />
                          {display_name}
                        </div>
                        <div className={styles.outputDescription}>
                          {test_value !== null ? test_value.replace(/\[,\]/g, ",") : ""}
                        </div>
                      </div>
                    </OutputItem>
                  ))}
                </OutputItemGroup>
              ),
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default SuggestUrl;
